/**
 * Formats a timepoint in seconds to a human-readable string
 * @param {number} timepoint - Time in seconds
 * @returns {string} Formatted time string (e.g., "2h30m45s" or "30m45s")
 */
export const formatTimepoint = (timepoint) => {
  const hours = ~~(timepoint / 3600);
  let minutes = ~~((timepoint - hours * 3600) / 60);
  let seconds = timepoint - hours * 3600 - minutes * 60;
  
  if (seconds < 10) {
    seconds = "0" + String(seconds);
  }
  seconds = String(seconds).slice(0, 2);
  
  if (minutes === 0) {
    minutes = "00";
  } else if (minutes < 10) {
    minutes = "0" + minutes;
  }

  if (hours > 0) {
    return hours + "h" + minutes + "m" + seconds + "s";
  } else if (minutes > 0) {
    return minutes + "m" + seconds + "s";
  }
  
  return minutes + "m" + seconds + "s";
};

/**
 * Parses transcription data from JSON string
 * @param {string} transcriptionData - JSON string of transcription
 * @returns {object|null} Parsed transcription object or null if invalid
 */
export const parseTranscription = (transcriptionData) => {
  try {
    return JSON.parse(transcriptionData);
  } catch {
    return null;
  }
};

/**
 * Extracts unique speakers from transcription data
 * @param {array} transcription - Transcription array
 * @returns {array} Array of unique speaker names
 */
export const extractSpeakers = (transcription) => {
  const speakers = [];
  transcription.forEach(segment => {
    const speaker = segment?.speaker;
    if (speaker && !speakers.includes(speaker)) {
      speakers.push(speaker);
    }
  });
  return speakers;
};

/**
 * Replaces speaker names in text content
 * @param {string} text - Text content to update
 * @param {string} oldName - Name to replace
 * @param {string} newName - New name
 * @returns {string} Updated text
 */
export const replaceSpeakerInText = (text, oldName, newName) => {
  const oldNameUppercase = oldName.charAt(0).toUpperCase() + oldName.slice(1).toLowerCase();
  const oldNameLowercase = oldName.charAt(0).toLowerCase() + oldName.slice(1).toLowerCase();
  const newNameFormatted = newName.charAt(0).toUpperCase() + newName.slice(1).toLowerCase();
  
  return text
    .replaceAll(oldNameLowercase, newNameFormatted)
    .replaceAll(oldNameUppercase, newNameFormatted);
}; 